import {mapActions, mapState} from "vuex";

export default {
    data() {
        return {
            timerScrolling: null
        }
    },
    methods: {
        ...mapActions('scrollModule', ['OPTIONS_HORIZONTAL_SCROLL', 'SET_CENTERED']),
        ...mapActions(['ACTIVE_FIXED_HEADER', 'IS_ACTIVE_HEADER_TRANSITION', 'ACTIVE_BLOCK', 'IS_SCROLL_PARENT']),
        scrollToTopBlock() {
            this.scrollToBlock({
                rout: ''
            })
        },
        scrollToBlock(item, isSmoothScroll = true) {
            clearTimeout(this.timerScrolling)
            this.IS_SCROLL_PARENT(true);
            this.scrollToBlockStatic(item.rout, isSmoothScroll);
            this.$router.push(`/${item.rout}`);
        },

        checkActiveClass() {
            const blocks = document.querySelectorAll('.watch-block')
            let blocksComputed = [];
            blocks.forEach(el => {
                    const rect = el.getBoundingClientRect()
                    let isVisible = rect.top <= (window.innerHeight / 2) && rect.bottom >= 0
                    if(isVisible) {
                        blocksComputed.push(el);
                    }
            })
            let blockLength = blocksComputed.length - 1;
            let block = blocksComputed?.[blockLength]
            this.ACTIVE_BLOCK(block ? block.className.split(' ')[0] || '' : '')
        },
        scrollToBlockStatic(rout, isSmoothScroll = true, isCentered = false) {
            let parent = document.querySelector('.sub-wrapper');
            let blockRout = rout === ''
                ? `#start`
                : `#${ rout }`
            let block = parent.querySelector(blockRout)
            if(this.lenis && !isCentered) {
                this.lenis.start();
                this.lenis?.scrollTo(block,
                    {
                        duration: isSmoothScroll ? 1 : 0.1,
                    })
                this.timerScrolling = setTimeout(() => {
                    this.IS_SCROLL_PARENT(false)
                }, isSmoothScroll ? 1000 : 0)
            } else {
                clearTimeout(this.timerScrolling)
                block?.scrollIntoView({
                    block: this.isActivePositionScroll(rout),
                    ...this.$isMobile ? { top: block?.offsetTop }: {},
                    behavior: isSmoothScroll ? "smooth" : 'auto',
                });
                this.timerScrolling = setTimeout(() => {
                    this.IS_SCROLL_PARENT(false)
                }, 600)
            }
            if(!isSmoothScroll) {
                this.$nextTick(() => {
                    this.IS_ACTIVE_HEADER_TRANSITION(true)
                })
            }
            if(!isCentered) {
                this.lenis?.start()
                this.SET_CENTERED(false);
            }
        },

        isActivePositionScroll(rout) {
            return rout === 'catalog'
            || rout === 'material'
            || rout === 'career'
            || rout === 'service'
                ? 'start'
                : 'center'
        },


    },
    computed: {
        ...mapState('scrollModule', ['optionsHorizontalScroll', 'lenis']),
        ...mapState(['$activeFixedHeader']),
        navigationStatic() {
            return [
                {
                    text: 'Преимущества',
                    rout: 'advantages'
                },
                {
                    text: 'Каталоги',
                    isActiveHeader: true,
                    class: 'catalog-screen-wrapper',
                    rout: 'catalog'
                },
                {
                    text: 'О компании',
                    isActiveHeader: true,
                    class: 'history-screen-container',
                    rout: 'about'
                },
                {
                    text: 'Наши компетенции',
                    class: 'service-screen-container',
                    isActiveHeader: true,
                    rout: 'service'
                },
                // {
                //     text: 'Кейсы',
                //     rout: 'case'
                // },
                {
                    text: 'Материалы',
                    rout: 'material'
                },
                {
                    text: 'Карьера',
                    class: 'career-screen-container',
                    isActiveHeader: true,
                    rout: 'career'
                }
            ]
        }
    }

    }